<div class="login-shell">
  <section class="login-hero" aria-label="DriveMe Academy Portal">
    <div class="login-brand">
      <img src="assets/brand/DMA_Logo_hoch_neg.png" alt="DriveMe Academy" class="login-brand-logo">
      <span class="login-brand-kicker">Schulungsportal</span>
    </div>

    <div class="login-hero-copy">
     
      <h1> Mobilität verändert sich, Professionalität bleibt.</h1>
      <p>
       Klare Abläufe für Fahrer, Unternehmer und Verwaltung.
      </p>
    </div>

    <div class="login-highlights" aria-hidden="true">
      <article>
        <span>Mehrsprachigkeit</span>
        <strong>Videos in diversen Sprachen</strong>
        <p>Lernmaterial kann einfacher verstanden werden.</p>
      </article>

      <article>
        <span>Prüfung mit Zertifikat</span>
        <strong>Zertifikat mit QR-Code</strong>
        <p>Echtheitszertifizierung der bestandenen Prüfung mittels QR-Code.</p>
      </article>

      <article>
        <span>Auditiert</span>
        <strong>Nachverfolgbar</strong>
        <p>Die Fortschritte der Prüfenden sind dauerhaft Nachverfolgbar und Fälschungssicher aufbewahrt.</p>
      </article>
    </div>
  </section>

  <section class="login-panel panel">
    <button
      type="button"
      class="skin-toggle login-skin-toggle"
      [attr.aria-label]="currentSkin() === 'modern-premium' ? 'Bright Skin aktivieren' : 'Dark Skin aktivieren'"
      [attr.title]="currentSkin() === 'modern-premium' ? 'Bright Skin aktivieren' : 'Dark Skin aktivieren'"
      (click)="toggleSkin()"
    >
      @if (currentSkin() === 'modern-premium') {
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <circle cx="12" cy="12" r="4"></circle>
          <path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.65 17.65l1.42 1.42M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.65 6.35l1.42-1.42"></path>
        </svg>
      } @else {
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M20.5 15.2A8.5 8.5 0 1 1 8.8 3.5 8.5 8.5 0 0 0 20.5 15.2Z"></path>
        </svg>
      }
    </button>

    <div class="login-panel-head">
      <span class="login-panel-badge">Zugang zum Portal</span>
      <h2>Mit DriveMe anmelden</h2>
      <p>Bitte E-Mail und Passwort eingeben.</p>
    </div>

    <form class="login-form form" [formGroup]="form" (ngSubmit)="submit()" autocomplete="on">
      <label>
        E-Mail
        <input
          type="email"
          formControlName="email"
          name="email"
          autocomplete="username"
          spellcheck="false"
          autocapitalize="none"
          placeholder="name@driveme.local"
        >
      </label>

      @if (submitted() && form.controls.email.invalid) {
        <p class="field-error">Bitte eine gültige E-Mail eingeben.</p>
      }

      <label class="password-field">
        Passwort
        <div class="password-input-row">
          <input
            [type]="showPassword() ? 'text' : 'password'"
            formControlName="password"
            name="password"
            autocomplete="current-password"
            spellcheck="false"
            placeholder="Passwort eingeben"
          >
          <button
            type="button"
            class="password-toggle"
            (click)="togglePasswordVisibility()"
            [attr.aria-label]="showPassword() ? 'Passwort verbergen' : 'Passwort anzeigen'"
            [attr.aria-pressed]="showPassword()"
          >
            @if (showPassword()) {
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M3.3 5.6 4.7 4.2l15.1 15.1-1.4 1.4-2.3-2.3c-1.2.4-2.6.6-4.1.6-5.9 0-10.1-3.9-12-7.5.9-1.7 2.3-3.4 4.2-4.8L3.3 5.6Zm4.6 4.6a4.1 4.1 0 0 0 5.7 5.7l-1.4-1.4a2.1 2.1 0 0 1-2.9-2.9L7.9 10.2Zm4-4c2.7 0 4.8 2.2 4.8 4.8 0 .7-.1 1.3-.4 1.9l-1.7-1.7a3 3 0 0 0-3.8-3.8L10.6 6.6c.5-.2 1.1-.4 1.3-.4Zm0-3.2c5.9 0 10.1 3.9 12 7.5-.8 1.6-2.1 3.1-3.8 4.4l-1.3-1.3c1.3-1 2.2-2.1 2.8-3.1-1.6-2.8-4.8-5.5-9.7-5.5-.9 0-1.8.1-2.6.3L8 5.8c1-.3 2.1-.4 3.2-.4Zm-6.1 6.1c1.6-2.1 4.1-3.8 7.4-3.8.7 0 1.4.1 2 .2l-1.7 1.7c-.1 0-.2 0-.3 0a4.1 4.1 0 0 0-4.1 4.1c0 .1 0 .2 0 .3l-1.8 1.8c-.8-.7-1.6-1.7-2.1-2.8a14.6 14.6 0 0 1 .6-1.5Z"/>
              </svg>
            } @else {
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M12 5c5.9 0 10.1 3.9 12 7.5-1.9 3.6-6.1 7.5-12 7.5S1.9 16.1 0 12.5C1.9 8.9 6.1 5 12 5Zm0 2C7.1 7 3.9 9.7 2.3 12.5 3.9 15.3 7.1 18 12 18s8.1-2.7 9.7-5.5C20.1 9.7 16.9 7 12 7Zm0 1.8a3.7 3.7 0 1 1 0 7.4 3.7 3.7 0 0 1 0-7.4Zm0 2a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4Z"/>
              </svg>
            }
          </button>
        </div>
      </label>

      @if (submitted() && form.controls.password.invalid) {
        <p class="field-error">Bitte ein Passwort eingeben.</p>
      }

      <label class="remember-row">
        <input type="checkbox" formControlName="rememberMe">
        <span>Angemeldet bleiben</span>
      </label>

      @if (error()) {
        <p class="empty login-error">{{ error() }}</p>
      }

      <button class="primary-button login-submit" type="submit" [disabled]="loading()">
        {{ loading() ? 'Anmeldung läuft...' : 'Anmelden' }}
      </button>

      <div class="login-footer">
        <p>
          Wenn du keinen Zugang hast, wende dich bitte an deine Zentrale.
        </p>
        <a class="table-link" routerLink="/forgot-password">Passwort vergessen?</a>
      </div>
    </form>
  </section>
</div>
